export enum FormateursPath {
  ROOT = '',
  EDITION = 'edition-formateur',
  EDITION_GENERAL = 'general',
  PLANNING = 'planning',
  CREATION = 'creation-formateur',
  ID_FORMATEUR_PARAM = 'idFormateur',
  DOCUMENTS = 'documents',
  TACHES = 'taches',
  FORMATIONS= "formations",
  COUTS_FORMATEUR = 'couts-formateur',
}
